import { BaseService, GET, QueryMap, Signal } from 'ts-retrofit3';

import type { InoResponse } from '@/Module/Core/Model/ApiModel';
import { InoHttpService } from '@/Module/Core/Service';
import { FAQ_API } from '@/Module/Question/Constant';
import type { IFAQ, IFAQGetList, IFAQGetTypeList, IFAQTypeList } from '@/Module/Question/Model';

class FAQService extends BaseService {
  @GET(FAQ_API.GET_LIST)
  async getFAQ(@QueryMap _query: IFAQGetList, @Signal _signal?: AbortSignal): Promise<InoResponse<IFAQ[]>> {
    return <InoResponse>{};
  }

  @GET(FAQ_API.GET_TYPE_LIST)
  async getFAQTypeList(
    @QueryMap _query: IFAQGetTypeList,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IFAQTypeList[]>> {
    return <InoResponse>{};
  }
}

export default InoHttpService.build(FAQService);
